"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var TypographyIcon = function (_a) {
    var icon = _a.icon;
    return (react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, content: "Find this icon in your editing toolbar to use this style" },
        react_1.default.createElement("div", { className: "typography-icon typography-icon--with-tooltip" }, icon)));
};
exports.default = TypographyIcon;
